// extracted by mini-css-extract-plugin
export default {"wrapper":"I01Ez","icon":"_1kNrT"};